export const GET_LEGAL_DOCUMENT = 'SAGA/GET_LEGAL_DOCUMENT';

export const getLegalDocument = (payload) => {
  return {
    type: GET_LEGAL_DOCUMENT,
    payload,
  };
};
